import * as React from 'react';
import { Typography } from 'fronton-react';
import { jc } from 'utils';
import * as styles from './review-answer.styles';
import { ReviewContentFormatter } from '../review-content-formatter';
import { AvatarWithFallback } from '../fronton-decorators/avatar-with-fallback';
import { personContainer } from './review-answer.styles';

type ReviewAnswerProps = {
  answererName: string;
  answererInitials: string;
  answererOccupation?: string | null;
  answererAvatarUrl?: string | null;
  text: React.ReactNode;
} & React.HTMLAttributes<HTMLElement>;

export const ReviewAnswer: React.FC<ReviewAnswerProps> = ({
  answererAvatarUrl,
  answererInitials,
  answererName,
  answererOccupation,
  text,
  className,
  ...htmlProps
}) => {
  return (
    <div className={jc(styles.reviewAnswerWrapper, className || '')} {...htmlProps}>
      <div className={styles.firstRow}>
        <AvatarWithFallback
          data-qa="review-avatar-fallback"
          name={answererInitials}
          imageSrc={answererAvatarUrl}
        />
        <div className={personContainer}>
          <div>
            <ReviewContentFormatter
              components={{
                p: ({ children }) => <PersonTitle>{children}</PersonTitle>,
                a: ({ children }) => <span>{children}</span>,
                link: ({ children }) => <span>{children}</span>,
              }}
            >
              {answererName}
            </ReviewContentFormatter>
          </div>
          {typeof answererOccupation === 'string' && answererOccupation.length > 0 && (
            <div>
              <ReviewContentFormatter
                components={{
                  p: ({ children }) => <PersonSubtitle>{children}</PersonSubtitle>,
                  a: ({ children }) => <span>{children}</span>,
                  link: ({ children }) => <span>{children}</span>,
                }}
              >
                {answererOccupation}
              </ReviewContentFormatter>
            </div>
          )}
        </div>
      </div>
      <Typography variant="m" size="body_long" color="text-primary" className={styles.reviewAnswerText}>
        {text}
      </Typography>
    </div>
  );
};

const PersonTitle: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Typography variant="m" size="subtitle" color="text-primary">
    {children}
  </Typography>
);

const PersonSubtitle: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Typography variant="caption" color="brand-primary">
    {children}
  </Typography>
);
